import Controller from '@/components/pages/price/PricePageController';
import getStaticPaths from '@/components/pages/price/PricePageStaticPaths';
import getStaticProps from '@/components/pages/price/PricePageStaticProps';

export default Controller;
export { getStaticProps, getStaticPaths };
